var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.visible,
        "before-close": _vm.onBeforeClose,
        width: "45rem",
        top: "5vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _vm.isSystemSubject
        ? _c("Masters-SystemSubjectForm", {
            attrs: {
              loading: _vm.formLoading,
              "submit-label": "Crear",
              "cancel-label": "Volver",
            },
            on: { cancel: _vm.onCancel, submit: _vm.onSubmit },
          })
        : _c("Masters-DefaultForm", {
            attrs: {
              loading: _vm.formLoading,
              "submit-label": "Crear",
              "cancel-label": "Volver",
            },
            on: { cancel: _vm.onCancel, submit: _vm.onSubmit },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }